

define(['squid/index', 'components/node-uuid/uuid'], function (squid, uuid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.marketingoffer', ['squid']).factory('$MarketingOfferModel', function ($Model, $Api) {
        return $Model.extend('$MarketingOfferModel', {
            api: new $Api({
                uri: '/api/checkout/offer/search-ads',
                postAttempts: 1

            }),

            serialize: function serialize() {
                var data = {
                    'locale': this.locale,
                    'si': this.si,
                    'visit_id': uuid.v4(),
                    'page': this.page,
                    'epu': this.payer,
                    'pu_type': this.puType || 'ANONYMOUS',
                    'country_code': this.countryCode,
                    'payment_context': {
                        'total_transaction_amount': this.totalTransactionAmount,
                        'total_shipping_amount': this.totalShippingAmount,
                        'business_case': 'NONE',
                        'business_case_variation': '',
                        'validate_existing_offer': 'false',
                        'payment_units': [{
                            'transaction_amount': this.totalTransactionAmount,
                            'transaction_id': '',
                            'encrypted_transaction_id': '',
                            'activity_id': '',
                            'payee': {
                                'pu_type': 'BUSINESS',
                                'country_code': this.countryCode,
                                'epu': this.payee,
                                'pu': ''
                            }
                        }]
                    },
                    'target_placements': this.targetPlacements
                };

                return data;
            }
        });
    }).service('$fireMORSBeacon', function ($q) {
        this.fireBeacon = function (uri) {
            var img = document.createElement('img');

            img.setAttribute('src', uri);
            document.body.appendChild(img);

            return;
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/marketingoffer/index.js
// module id = ./components/xo-models/src/marketingoffer/index.js
// module chunks = 1